import { call, put, select, spawn } from 'redux-saga/effects';

import { createRegFilingType } from '@api/filingTypes';
import { filingTypesSetModel } from '@models/filingTypes';
import { history, jurisdictionsRoutes } from '@routes';
import {
  filingTypesCreateFailure,
  filingTypesCreateSuccess,
} from '@store/entityJurisdictions/entityJurisdictionsDetail/filingTypes/filingTypes.reducer';
import { toastError, toastSuccess } from '@store/notifications';
import { filingNameSelector } from '@store/selectors/registrations';

import { filingTypesFetchSaga } from '../filingTypesFetchSaga';

export const filingTypesCreateSaga = function* ({ payload }) {
  try {
    yield call(
      createRegFilingType,
      filingTypesSetModel({
        ...payload.data,
        entityJurisdictionId: payload.entityJurisdictionId,
      })
    );

    const filingName = yield select(filingNameSelector, payload.data?.filingType);

    yield put([
      filingTypesCreateSuccess(),
      toastSuccess({
        message: {
          defaultMessage: '{filingName} created successfully.',
          id: 'pages.registrations.filing-types-create.notification.success',
        },
        values: {
          filingName,
        },
      }),
    ]);

    yield spawn(filingTypesFetchSaga, {
      payload: { entityJurisdictionId: payload.entityJurisdictionId },
    });

    yield call(
      history.replace,
      jurisdictionsRoutes.DETAIL.make({
        entityId: payload.entityId,
        entityJurisdictionId: payload.entityJurisdictionId,
      })
    );
  } catch (error) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = error.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    const filingName = yield select(filingNameSelector, payload.data?.filingType);

    yield put([
      toastError(
        hasNonFieldError
          ? {
              message: nonFieldErrors,
            }
          : {
              message: {
                defaultMessage: 'Failed to create {filingName}.',
                id: 'pages.registrations.filing-types-create.notification.error',
              },
              values: {
                filingName,
              },
            }
      ),
      filingTypesCreateFailure(),
    ]);

    yield call(payload.setSubmitting, false);
  }
};
